/**
 * Shopify Forms — theme branding via window.formStyles
 *
 * Loaded in layout/theme.liquid before {{ content_for_header }}.
 * Tokens mirror Tailwind / assets/tailwind.css (.form-card).
 *
 * @see https://community.shopify.dev/t/custom-css-in-embedded-shopify-forms/12178
 */
window.formStyles = window.formStyles || new Map();

window.formStyles.set('alien-shop-theme', `
  :host {
    --forms-body-font: "Space Grotesk", system-ui, sans-serif;
    --forms-heading-font: "Space Grotesk", system-ui, sans-serif;
    --forms-base-font-size: 15px;
    --form-container-background-color: transparent;
    --form-field-gap: 24px;
  }

  /* Field stack — gap-6 (24px), matches .form-fields */
  [class*="_formFieldset"] {
    gap: 24px !important;
  }

  /*
   * Shopify Forms adds ::before on each field container as an internal
   * spacer for floating-label layout (height + negative margin). Redundant
   * once we set gap on the fieldset — hide it to avoid double spacing.
   */
  [class*="_formFieldContainer"]::before {
    display: none !important;
    content: none !important;
    height: 0 !important;
    margin: 0 !important;
  }

  /* Outer shell — no background (page/section shows through) */
  [class*="_inline_"],
  [class*="_appEmbedRoot"] {
    background: transparent !important;
    background-color: transparent !important;
  }

  /* App layout wrapper — strip redundant box styles (card lives on form-wrapper) */
  #form-container-ref {
    background: none !important;
    background-color: transparent !important;
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }
  .phone-country-selector button {
    max-height: unset !important;
    background-color: #fbfbf7 !important;
  }
  /* form-wrapper — matches .form-card / max-w-2xl mx-auto … */
  [data-sizing="form-wrapper"],
  [class*="_formContainer"] {
    box-sizing: border-box !important;
    width: 100% !important;
    max-width: 42rem !important;
    margin-left: auto !important;
    margin-right: auto !important;
    background-color: #ffffff !important;
    padding: 2rem !important;
    border-radius: 1.5rem !important;
    border: 1px solid #e7e3da !important;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
    transition: box-shadow 300ms !important;
  }

  [data-sizing="form-wrapper"]:hover,
  [class*="_formContainer"]:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1) !important;
  }

  @media (min-width: 768px) {
    [data-sizing="form-wrapper"],
    [class*="_formContainer"] {
      padding: 3rem !important;
    }
  }

  /* heading — text-3xl font-bold text-brand-dark mb-4 tracking-tight */
  [class*="_textHeading"],
  [class*="_formHeader"] h2 {
    font-family: "Space Grotesk", system-ui, sans-serif !important;
    font-size: 1.875rem !important;
    line-height: 2.25rem !important;
    font-weight: 700 !important;
    color: #001440 !important;
    margin-bottom: 1rem !important;
    letter-spacing: -0.025em !important;
  }

  /* description — text-text-secondary font-medium */
  [class*="_textBody"],
  [class*="_formHeader"] p {
    font-family: "Space Grotesk", system-ui, sans-serif !important;
    font-size: 1rem !important;
    font-weight: 500 !important;
    color: #5f6368 !important;
  }

  label {
    font-family: "Space Grotesk", system-ui, sans-serif !important;
    font-weight: 500 !important;
    color: #5f6368 !important;
  }

  input,
  textarea {
    font-family: "Space Grotesk", system-ui, sans-serif !important;
    font-size: 15px !important;
    color: #1a1a1a !important;
    background-color: rgb(251, 251, 248) !important;
    border-radius: 12px !important;
  }

  input:focus,
  textarea:focus {
    outline: none !important;
    background-color: #ffffff !important;
    box-shadow: 0 0 0 2px rgba(137, 189, 42, 0.2) !important;
  }

  button[type="submit"] {
    font-family: "Space Grotesk", system-ui, sans-serif !important;
    font-weight: 700 !important;
    background-color: #89bd2a !important;
    color: #ffffff !important;
    border-radius: 9999px !important;
  }

  button[type="submit"]:hover {
    background-color: #73a91f !important;
  }

  [class*="_formDisclaimer"] {
    font-family: "Space Grotesk", system-ui, sans-serif !important;
    font-size: 0.75rem !important;
    font-weight: 500 !important;
    color: #5f6368 !important;
  }

  [class*="_formDisclaimer"] a {
    color: #5f6368 !important;
  }

  [class*="_formDisclaimer"] a:hover {
    color: #89bd2a !important;
  }
`);
